import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import AnniversaryMonth from "./AnniversaryMonth";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./AnniversariesReport.css";

function AnniversariesReport() {
  const [isLoading, setIsLoading] = useState(true);
  const [anniversaryData, setAnniversaryData] = useState([]);

  const { state } = useContext(AuthContext);

  let { rid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/reports/users/work-anniversaries/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      setAnniversaryData(response.data.anniversaryArray);
      setIsLoading(false);
    }
    fetch();
  }, [rid, state.token]);

  if (isLoading) {
    return (
      <Container className="report-container">
        <Row>
          <Col>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        </Row>
      </Container>
    );
  } else {
    return (
      <Container className="anniversaries-report">
        <Row>
          <Col>
            {anniversaryData.map((item) => {
              if (item.count > 0) {
                return (
                  <AnniversaryMonth
                    key={item.title}
                    title={item.title}
                    title_english={item.title_english}
                    users={item.users}
                    count={item.count}
                    language={state.language}
                  />
                );
              } else {
                return <></>;
              }
            })}
          </Col>
        </Row>
      </Container>
    );
  }
}

export default AnniversariesReport;
